import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UpdateResult } from "./update-result";
import { MatFormFieldModule } from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MatDialogModule
} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
@Component({
  selector: 'app-update-dialog',
  templateUrl: './update-dialog.component.html',
  standalone: true,
  imports: [MatFormFieldModule,
    ReactiveFormsModule, MatButtonModule, FormsModule, MatInputModule, MatDialogModule
  ],
  styleUrls: ['./update-dialog.component.scss']
})
export class UpdateDialogComponent implements OnInit {

  formGroup!: FormGroup;

  constructor(private dialogRef: MatDialogRef<UpdateDialogComponent, UpdateResult>,
              private _formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.formGroup = this._formBuilder.group({
      clientRefCtrl: ['', Validators.required]
    });

    if (this.data.clientRef) {
      this.formGroup.get('clientRefCtrl')?.setValue(this.data.clientRef);
    }
  }

  onCancel(): void {
    this.dialogRef.close({
      toUpdate: false,
      clientRef: ''
    });
  }

  onSave(): void {
    if (this.validateForm()) {
      this.dialogRef.close({
        toUpdate: true,
        clientRef: this.formGroup.get('clientRefCtrl')?.value
      });
    }
  }

  validateForm(): boolean {
    const value = this.formGroup.get('clientRefCtrl')?.value;
    return value && value != this.data.clientRef;
  }
}
